import { Button } from "@mui/material";

const PrimaryButtom = ({
  fullWidth = true,
  background,
  sx,
  onClick,
  endIcon,
  startIcon,
  variant = "contained",
  text,
  disabled = false,
}) => {
  return (
    <Button
      disabled={disabled}
      fullWidth={fullWidth}
      variant={variant}
      sx={{
        background:
          background || `linear-gradient(90deg, #1DA7A7 0%, #0F7A6D 100%)`,
        // borderRadius: 3,
        fontWeight: 600,
        textTransform: "none",
        border: "none",
        "&:hover": {
          border: "none",
          opacity: 0.9,
          background:
            background || `linear-gradient(90deg, #1DA7A7 0%, #0F7A6D 100%)`,
        },
        ...sx,
      }}
      onClick={onClick}
      endIcon={endIcon}
      startIcon={startIcon}
    >
      {text}
    </Button>
  );
};

export default PrimaryButtom;
